/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentDataSurveyAnswers model module.
 * @module model/StudentDataSurveyAnswers
 * @version 1.0.0
 */
class StudentDataSurveyAnswers {
    /**
     * Constructs a new <code>StudentDataSurveyAnswers</code>.
     * @alias module:model/StudentDataSurveyAnswers
     */
    constructor() { 
        
        StudentDataSurveyAnswers.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentDataSurveyAnswers</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentDataSurveyAnswers} obj Optional instance to populate.
     * @return {module:model/StudentDataSurveyAnswers} The populated <code>StudentDataSurveyAnswers</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentDataSurveyAnswers();

            if (data.hasOwnProperty('question_id')) {
                obj['question_id'] = ApiClient.convertToType(data['question_id'], 'Number');
            }
            if (data.hasOwnProperty('answer_id')) {
                obj['answer_id'] = ApiClient.convertToType(data['answer_id'], 'Number');
            }
            if (data.hasOwnProperty('specification')) {
                obj['specification'] = ApiClient.convertToType(data['specification'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Question identifier
 * @member {Number} question_id
 */
StudentDataSurveyAnswers.prototype['question_id'] = undefined;

/**
 * Selected answer identifier
 * @member {Number} answer_id
 */
StudentDataSurveyAnswers.prototype['answer_id'] = undefined;

/**
 * Additional specification provided by the student
 * @member {String} specification
 */
StudentDataSurveyAnswers.prototype['specification'] = undefined;






export default StudentDataSurveyAnswers;

